// hooks/music/useEditMusic.js
import React from "react";
// import axios from "axios";
// import { toast } from "react-toastify";
import useCreate from "../useCreate"; // Adjust the path as necessary
import { TOKEN_KEY } from "../../config";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../apis/axios";

const TOKEN = sessionStorage.getItem(TOKEN_KEY);

export const fetchSingleCalorie = async (foodItemId) => {
  try {
    // Ensure that the URL includes the musicId for fetching specific music details
    const response = await axios.get(
      `food/fetch_single_food_items?foodItemId=${foodItemId}`,
      {
        headers: {
          Authorization: TOKEN ? `Bearer ${TOKEN}` : "",
        },
      }
    );

    // Return the data from the response
    return response.data;
  } catch (error) {
    // Handle errors appropriately
    toast.error("Error fetching calorie details!");
    console.error("Error fetching calorie details:", error);
    throw error;
  }
};
// const { musicId } = useParams();
const useEditCalorie = () => {
    const navigate = useNavigate();
  const { setDataToServer: updateCalorie } = useCreate({
    refreshUrl: "food/food_item_listing",
    url: "food/update_food_items",
    onSuccess: () => {
      toast.success("Music updated successfully!");
    },
    onError: () => {
      toast.error("Error updating music!");
    },
  });

  const handleEditForm = (data, onSuccess, onError) => {
    updateCalorie.mutate(data, {
      onSuccess: (response) => {
        toast.success("Calorie updated successfully!");
        if (onSuccess) onSuccess(response); // Call custom onSuccess if provided
        navigate(-1);
      },
      onError: (error) => {
        toast.error("Error updating calorie!");
        if (onError) onError(error); // Call custom onError if provided
      },
    });
  };

  return { fetchSingleCalorie, updateCalorie, handleEditForm };
};

export default useEditCalorie;
